<template>
  <div>
    <vx-card id="queue_history" :title="$t('queue_history')" class="mb-8" :collapse-action="false" v-if="this.$store.getters.hasCompanyPermission('company_can_use_queue_history')">
      <div class="vx-row queue-history" >
        <div class="vx-col w-full mb-5">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <date-picker v-model="queueHistorySearchParams.date" :model="queueHistorySearchParams.date" value-type="format" format="YYYY-MM-DD" :placeholder="$t('date')" class="w-full" :append-to-body="false"></date-picker>
            </div>
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <v-select :options="timeOptions" :reduce="label => label.value" :placeholder="$t('all')" v-model="queueHistorySearchParams.time" class="mb-3" />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button color="success" type="filled" class="w-full" @click.prevent="searchQueueHistory()" v-text="$t('search')"></vs-button>
            </div>
          </div>
        </div>
        <div class="vx-col w-full">
          <vs-table hover-flat v-if="results && results.length" :data="results">
            <template slot="thead">
              <vs-th v-text="$t('time')"></vs-th>
              <vs-th v-text="$t('total_income')"></vs-th>
              <vs-th v-text="$t('answered')"></vs-th>
              <vs-th v-text="$t('response_rate')"></vs-th>
              <vs-th v-text="$t('real_income')"></vs-th>
              <vs-th v-text="$t('real_answered')"></vs-th>
              <vs-th v-text="$t('real_response_rate')"></vs-th>
              <vs-th v-text="$t('abandonment_issue')"></vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="key" v-for="(tr, key) in data">
                <vs-td v-text="tr.time"></vs-td>
                <vs-td v-text="tr.total_income"></vs-td>
                <vs-td v-text="tr.answered"></vs-td>
                <vs-td v-text="tr.response_rate"></vs-td>
                <vs-td v-text="tr.real_income"></vs-td>
                <vs-td v-text="tr.real_answered"></vs-td>
                <vs-td v-text="tr.real_response_rate"></vs-td>
                <vs-td v-text="tr.abandonment_issue"></vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>

import Queue from '@/models/Queue'

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  name: 'Window.Queues.CdrHistory',
  components: {
    DatePicker
  },
  data () {
    return {
      results: {},
      timeOptions: [],
      queueHistorySearchParams: {
        date: typeof this.$route.query.date !== 'undefined' ? this.$route.query.date : '',
        queue_number: typeof this.$route.query.queue_number !== 'undefined' ? this.$route.query.queue_number : '',
        time: typeof this.$route.query.time !== 'undefined' ? this.$route.query.time : ''
      }
    }
  },
  mounted () {
    this.timeOptions = []
    let index = 0
    for (let i = 1; i <= 10; i++) {
      const label = (8 + i)
      this.timeOptions.push({
        label: `${label}:00`,
        value: index.toString()
      })
      index++
    }
    this.searchQueueHistory()
  },
  methods: {
    async searchQueueHistory () {
      this.$vs.loading({container: '#queue_history'})
      if (this.$store.getters.hasCompanyPermission('company_can_use_queue_history')) {
        this.$router.replace({ query: this.queueHistorySearchParams })
        const historyResponse = await Queue.cdrHistory({...this.queueHistorySearchParams})
        this.results = historyResponse.data.results
      }
      this.$vs.loading.close('#queue_history > .con-vs-loading')
    }
  }
}
</script>

<style scoped>

</style>
